import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { NpsService } from 'src/app/services/nps/nps.service';

@Component({
  selector: 'app-nps-survey',
  templateUrl: './nps-survey.component.html',
  styleUrls: ['./nps-survey.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('backdropAnim', [
      state('void', style({ opacity: 0 })),
      state('visible', style({ opacity: 1 })),
      transition('void => visible', animate('300ms ease-out')),
      transition('visible => void', animate('250ms ease-in'))
    ]),
    trigger('modalAnim', [
      state('void', style({ opacity: 0, transform: 'scale(0.85) translateY(-30px)' })),
      state('visible', style({ opacity: 1, transform: 'scale(1) translateY(0)' })),
      transition('void => visible', animate('350ms cubic-bezier(0.34, 1.56, 0.64, 1)')),
      transition('visible => void', animate('250ms cubic-bezier(0.4, 0, 0.2, 1)'))
    ])
  ]
})
export class NpsSurveyComponent implements OnInit, OnDestroy {
  @Input() exposureId
  @Input() question = 'עד כמה סביר שתמליץ/י על נתיב לחבר או קולגה?';
  @Output() closed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<{ score: number; comment: string }>();

  scores = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  selectedScore: number | null = null;
  comment = '';
  animState = 'visible';
  isClosing = false;

  constructor(private cdr: ChangeDetectorRef, private npsService: NpsService) { }

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }

  selectScore(score: number): void {
    this.selectedScore = score;
    this.cdr.detectChanges();
  }

  getScoreClass(score: number): string {
    return `btn-score btn-score--${score}`;
  }

  closeModal(): void {
    if (this.isClosing) return;
    this.isClosing = true;
    this.animState = 'void';
    this.cdr.markForCheck();
    this.npsService.updateNps(this.exposureId, null, null).subscribe()
    setTimeout(() => this.closed.emit(), 270);
  }

  submitFeedback(): void {
    if (this.selectedScore === null || this.isClosing) return;
    this.isClosing = true;
    this.animState = 'void';
    this.npsService.updateNps(this.exposureId, this.selectedScore, this.comment).subscribe()
    this.cdr.markForCheck();
    setTimeout(() => {
      this.closed.emit();
    }, 270);
  }
}
